const playBtns = document.querySelectorAll<HTMLElement>('.video-inline__play');
const autoplayVideos = document.querySelectorAll<HTMLElement>(
	'.video-inline--autoplay:not(.video-inline--lazy)'
);
const lazyVideos = document.querySelectorAll<HTMLElement>('.video-inline--lazy');

function initAutoplayVideo(video: HTMLElement) {
	const iframe = video.querySelector<HTMLIFrameElement>('iframe');
	if (!iframe || iframe.classList.contains('playing')) return;

	if (video.classList.contains('video-inline--no-mobile') && window.innerWidth < 992) {
		iframe.removeAttribute('src');
		return;
	}

	if (window.Vimeo?.Player) {
		const player = new window.Vimeo.Player(iframe);
		player.on('play', () => {
			iframe.classList.add('playing');
		});
		player.getPaused().then((paused: boolean) => {
			if (!paused) {
				iframe.classList.add('playing');
			}
		});
	}
}

function initInlineVideo(video: HTMLElement) {
	const iframe = video.querySelector<HTMLIFrameElement>('iframe');
	if (!iframe || !iframe.src) return;

	if (window.Vimeo?.Player) {
		const player = new window.Vimeo.Player(iframe);
		player.ready().then(() => {
			iframe.classList.add('visible');
		});
		player.on('play', () => {
			iframe.classList.add('playing');
		});
		player.on('pause', () => {
			iframe.classList.remove('playing');
		});
	}
}

function initAutoplayVideos() {
	autoplayVideos.forEach(initAutoplayVideo);
}

window.addEventListener('load', initAutoplayVideos);
window.addEventListener('rocket-allScriptsLoaded', initAutoplayVideos);

if (lazyVideos.length > 0) {
	const lazyObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				const video = entry.target as HTMLElement;
				const iframe = video.querySelector<HTMLIFrameElement>('iframe');
				if (!iframe) return;

				const dataSrc = iframe.getAttribute('data-src');
				if (dataSrc) {
					iframe.src = dataSrc;
				}

				if (video.classList.contains('video-inline--autoplay')) {
					initAutoplayVideo(video);
				} else {
					initInlineVideo(video);
				}
				lazyObserver.unobserve(video);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	lazyVideos.forEach((video) => lazyObserver.observe(video));
}

playBtns.forEach((playBtn) => {
	playBtn.addEventListener('click', () => {
		const media = playBtn.parentElement;
		if (!media) return;

		media.classList.add('component-media--show-video');

		const video = media.querySelector<HTMLElement>('.video-inline');
		if (!video) return;

		video.classList.add('video-inline--is-visible');
		playBtn.style.display = 'none';

		const iframe = video.querySelector<HTMLIFrameElement>('iframe');
		if (!iframe) return;

		const videoSrc = iframe.getAttribute('data-src');
		if (!videoSrc) return;

		iframe.src = videoSrc;
		iframe.classList.add('visible');

		if (videoSrc.includes('vimeo')) {
			const player = new window.Vimeo.Player(iframe);
			let currentPercent = 0;

			Promise.all([player.getVideoTitle(), player.getVideoUrl()]).then(
				([videoTitle, videoUrl]: [string, string]) => {
					const pushToDataLayer = (action: string, percent: number) => {
						window.dataLayer = window.dataLayer || [];
						/* eslint-disable camelcase */
						window.dataLayer.push({
							event: 'video',
							video_action: action,
							video_percent: percent,
							video_title: videoTitle,
							video_url: videoUrl,
						});
						/* eslint-enable camelcase */
					};

					player.on('play', () => {
						iframe.classList.add('playing');
						pushToDataLayer('start', currentPercent);
					});

					player.on('pause', () => {
						pushToDataLayer('pause', currentPercent);
					});

					player.on('ended', () => {
						pushToDataLayer('complete', 100);
					});

					player.on('timeupdate', (data: { percent: number }) => {
						currentPercent = Math.floor(data.percent * 100);
					});
				}
			);
		}
	});
});
